import { defineComponent as _defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import { useArticlesStore } from '@/stores/articles';
import { computed, nextTick, onMounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Pagination from '@/components/Pagination.vue';
import ArticlesFilters from '@/components/ArticlesFilters.vue';
import ArticlesOrder from '@/components/ArticlesOrder.vue';
import ArticlesSort from '@/components/ArticlesSort.vue';
import { storeToRefs } from 'pinia';
import ArticlesItem from '@/components/ArticlesItem.vue';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import LoadingError from '@/components/LoadingError.vue';
import ArticlesMenu from '@/components/ArticlesMenu.vue';
import ArticlesDetails from '@/components/ArticlesDetails.vue';
import ArticlesClearAllFilter from '@/components/ArticlesClearAllFilter.vue';
import { animateInViewport } from '@/transition.js';
import { Tab, TabGroup, TabList } from '@headlessui/vue';
import { useShortLengthsOverview } from '@/utils/utils';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ArticlesContent',
    setup(__props, { expose: __expose }) {
        __expose();
        const { t: $t } = useI18n();
        const route = useRoute();
        const router = useRouter();
        const articlesStore = useArticlesStore();
        const isShortLengthsOverview = useShortLengthsOverview();
        const { pagination } = storeToRefs(articlesStore);
        articlesStore.fetchStats();
        articlesStore.fetchArticleGroups().finally(() => {
            return articlesStore.fetchArticlesFromQuery(route);
        });
        watch(() => route.query, async (query, oldQuery) => {
            if ((query.startIndex > 1 || oldQuery?.startIndex > 1) &&
                query.startIndex !== oldQuery?.startIndex) {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                });
            }
            await articlesStore.fetchArticlesFromQuery(route);
        });
        const productsMainCategoriesRef = ref(null);
        const productsMainCategoriesElement = ref(document.getElementById('products-main-categories')?.innerHTML);
        onMounted(async () => {
            await nextTick();
            animateInViewport();
        });
        watch([() => articlesStore.isLoadingStats, productsMainCategoriesElement], async () => {
            if (!articlesStore.isLoadingStats) {
                await nextTick();
                animateInViewport();
                if (productsMainCategoriesRef.value) {
                    for (const link of productsMainCategoriesRef.value.querySelectorAll('a')) {
                        link.addEventListener('click', (event) => {
                            event.preventDefault();
                            router.push({
                                query: Object.fromEntries(new URL(link.href, window.location.origin).searchParams),
                            });
                        });
                    }
                }
            }
        });
        watch(() => route.query, async (query, oldQuery) => {
            if (!query?.articleGroup) {
                articlesStore.details = null;
                articlesStore.detailsError = null;
                articlesStore.isLoadingDetails = false;
            }
            else if (query?.articleGroup !== oldQuery?.articleGroup) {
                await articlesStore.fetchArticleDetails(query.articleGroup);
            }
            if (Object.keys(route.query).length > 0) {
                productsMainCategoriesElement.value = '';
            }
            else {
                productsMainCategoriesElement.value = document.getElementById('products-main-categories')?.innerHTML;
            }
        }, { immediate: true });
        const selectedTab = computed(() => (route.query.remainders === '1' ? 1 : 0));
        function changeTab(tabIndex) {
            router.push({
                query: {
                    ...route.query,
                    remainders: tabIndex === 1 ? 1 : undefined,
                    startIndex: 1,
                },
            });
        }
        const __returned__ = { $t, route, router, articlesStore, isShortLengthsOverview, pagination, productsMainCategoriesRef, productsMainCategoriesElement, selectedTab, changeTab, Pagination, ArticlesFilters, ArticlesOrder, ArticlesSort, ArticlesItem, LoadingSpinner, LoadingError, ArticlesMenu, ArticlesDetails, ArticlesClearAllFilter, get Tab() { return Tab; }, get TabGroup() { return TabGroup; }, get TabList() { return TabList; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
